import z from "zod"

const batchUpdateKeys = [
  "productionSiteId",
  "purchaseOrderRef",
  "reference",
  "contactId",
  "doNotKnow",
  "customFieldsValues",
] as const

export const BatchUpdateKeysEnum = z.enum(batchUpdateKeys)
export type BatchUpdateKeysType = z.infer<typeof BatchUpdateKeysEnum>

export type FindOperationsWithEmptyFieldsQuery = BatchUpdateKeysType

export const validateIdArrayQueryParamsSchema = z
  .string()
  .transform((val) => val.split(",").map((id) => Number(id.trim())))
  .refine((arr) => arr.every((num) => !isNaN(num)), {
    // Ensure all elements are valid numbers
    error: "All IDs must be valid numbers",
  })

export const FindOperationsWithEmptyFieldsRequestDTOSchema = z.object({
  ids: validateIdArrayQueryParamsSchema,
  key: BatchUpdateKeysEnum,
  customFieldDefinitionId: z.coerce.number().optional(),
})
export type FindOperationsWithEmptyFieldsRequestDTO = z.infer<
  typeof FindOperationsWithEmptyFieldsRequestDTOSchema
>
